import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { api } from "../api/api";
import { aclReducer } from "./reducers/acl/acl.reducer";
import { authReducer } from "./reducers/auth/auth.reducer";

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  acl: aclReducer,
  authReducer,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;

export const setupStore = (preloadedState?: Partial<RootState>) =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      // adding the api middleware enables caching, invalidation, polling and other features of `rtk-query`
      getDefaultMiddleware().concat(api.middleware),
    preloadedState,
  });

export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
